export default __webpack_public_path__ + "static/media/right-arrow.icon.289e45f2.svg";